exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "form[data-v-41a07e9c]{padding:1em}fieldset[data-v-41a07e9c]{border:none;margin:1em}label[data-v-41a07e9c]{font-weight:700;line-height:3em}input[data-v-41a07e9c]{padding:1em;width:100%}textarea[data-v-41a07e9c]{padding:1em;width:100%;height:300px;resize:none}.preview-area[data-v-41a07e9c]{padding:4em 1em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-41a07e9c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TaskForm.vue
// module id = 111
// module chunks = 0